import { useEffect, useState } from "react";
import IVacancy from "../../../models/recruitment/IVacancy";
import { useTranslation } from "react-i18next";
import Status from "../../../enums/Status";
import recruitmentService from "../../../services/RecruitmentService";
import { Dropdown, Field, makeStyles, Option, OptionGroup } from "@fluentui/react-components";

interface IVacancyDropdownProps {
    selectedVacancyId?: number;
    onVacancyChange: (vacancyId: number) => void;
    disabled: boolean;
}

const useStyles = makeStyles({
    root: {
        marginBottom: "20px"
    }
});

export default function VacancyDropdown(props: IVacancyDropdownProps) {
    const { t } = useTranslation("recruitment");
    const styles = useStyles();

    const [status, setStatus] = useState<Status>(Status.LOADING);
    const [vacancies, setVacancies] = useState<IVacancy[]>([]);

    useEffect(() => {
        getVacancies(setVacancies, setStatus);
    }, []);

    const handleChange = (vacancyId?: string) => {
        const value = !!vacancyId ? Number(vacancyId) : -1;
        props.onVacancyChange(value);
    }

    const value = props.selectedVacancyId !== -1
        ?   (
                vacancies.find(v => Number(v.ID) === Number(props.selectedVacancyId))?.title ||
                (props.selectedVacancyId === 0 ? t("register.form.generalApplication") : t("register.form.selectPosition"))
            )
        : t("register.form.selectPosition");

    const disabled = props.disabled || status === Status.LOADING || status === Status.LOAD_ERROR;

    return (
        <div className={styles.root}>
            <Field label={t("register.form.applyingFor")}>
                <Dropdown
                    value={value}
                    disabled={disabled}
                    selectedOptions={[props.selectedVacancyId !== -1 ? String(props.selectedVacancyId) : ""]}
                    onOptionSelect={(_, data) => handleChange(data.optionValue)}
                >
                    <Option value="0">
                        {t("register.form.generalApplication")}
                    </Option>
                    {
                        vacancies.length > 0 &&  
                        <OptionGroup label={t("register.form.currentVacancies")}>
                        {
                            vacancies.map(v => <Option key={v.ID} value={v.ID.toString()}>{v.title}</Option>)
                        }
                        </OptionGroup>                          
                    }
                </Dropdown>
            </Field>
        </div>
    );
}

async function getVacancies (
    setVacancies: (vacancies: IVacancy[]) => void,
    setStatus: (status: Status) => void
) {
    setStatus(Status.LOADING);

    try {
        const vacancies = await recruitmentService.getVacancies();

        setVacancies(vacancies);
        setStatus(Status.LOAD_SUCCESS);
    } catch (error) {
        setStatus(Status.LOAD_ERROR);
    }
}